import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'performance_process/cycles',
} as const satisfies Location
